export const DAY_OPTIONS = intl => [
    { label: intl.get('dataBoard.days7'), value: 7 },
    { label: intl.get('dataBoard.days30'), value: 30 },
    { label: intl.get('dataBoard.days90'), value: 90 },
    { label: intl.get('dataBoard.days365'), value: 365 },
];

export const pieOption = {
    tooltip: {
        trigger: 'item',
        borderWidth: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.96)',
        textStyle: {
            color: 'rgba(0, 0, 0, 0.8)',
            fontSize: 12,
        },
    },
    legend: {
        left: 15,
        top: 'center',
        orient: 'vertical',
        icon: 'circle',
        itemWidth: 8,
        itemHeight: 8,
        textStyle: {
            color: 'rgba(0, 0, 0, 0.8)',
        },
    },
};

export const barOption = {
    color: ['#5781EE', '#EFB353', '#71E4B7'],
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
        },
        textStyle: {
            fontSize: 12,
        },
        backgroundColor: 'rgba(255,255,255,.96)',
        borderColor: 'rgba(255,255,255,.96)',
        extraCssText: 'box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.10)',
    },
    grid: {
        top: 20,
        bottom: 40,
        containLabel: true,
    },
    legend: {
        bottom: 10,
        left: 'center',
        icon: 'circle',
        itemWidth: 8,
        itemHeight: 8,
        textStyle: {
            color: 'rgba(0, 0, 0, 0.8)',
        },
    },
    yAxis: {
        type: 'value',
    },
};

// 数据在X轴的条状图配置
export const xBarOption = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
        },
    },
    grid: {
        top: 40,
        bottom: 80,
        containLabel: false,
        left: 120,
    },
    legend: {
        show: false,
    },
    xAxis: {
        type: 'value',
        splitLine: {
            show: false,
        },
        axisLabel: {
            color: 'rgba(0,0,0,0.4)',
        },
        axisLine: {
            show: true,
            lineStyle: {
                color: '#E3E7F2',
            },
        },
        offset: 40,
        bottom: 1,
    },
};

export const downloadExcel = async (res, name) => {
    if (res.headers['content-type'].includes('application/json')) {
        const jsonRes = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = e => {
                resolve(JSON.parse(e.target.result));
            };
            reader.readAsText(res.data);
        });
        return Promise.reject(jsonRes);
    } else {
        const blob = new Blob([res.data]);
        let obkectUrl = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = obkectUrl;
        a.download = name + '.xls';
        a.click();
        window.URL.revokeObjectURL(blob);
    }
};
